import DisplayItem from '@/models/DisplayItem';
import Item from '@/models/Item';
import ItemStatus from '@/status/ItemStatus';
import Utility from '@/util/Utility';
import ITestReviewDisplayStrategy from './ITestReviewDisplayStrategy';

class TestReviewScreenDisplayStrategy implements ITestReviewDisplayStrategy {
  getText(adjustedDisplayItems: Array<DisplayItem>): string {
    const i18n = (window as any).i18n.global;
    const incompleteCount = this.getItemCount(adjustedDisplayItems, (item: Item) => {
      return item.itemStatus !== ItemStatus.FULLY_ATTEMPTED;
    });
    const flagCount = this.getItemCount(adjustedDisplayItems, (item: Item) => {
      return item.isFlagged;
    });

    if (incompleteCount + flagCount > 0) {
      const text = Utility.getIncompleteAndFlaggedText(
        incompleteCount,
        flagCount,
        (count: number) => {
          return this.getSpan(
            '<b>' +
              count +
              '</b>' +
              ' ' +
              (count > 1 ? i18n.t('review.incomplete_plural') : i18n.t('review.incomplete')),
            '#FFE5E5',
            '#8E1212'
          ); //'#fff3c1', '#9A8630'
        },
        (count: number) => {
          return this.getSpan('<b>' + count + '</b>' + ' ' + i18n.t('review.flagged'), '#FFE5E5', '#8E1212');
        }
      );

      return text + i18n.t('review.confirm');
    }

    return '';
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getDisplayHeight(hidden: boolean): string {
    return '100%';
  }

  isScreenDisplay(): boolean {
    return true;
  }

  createStyle(): Map<string, string> {
    const map: Map<string, string> = new Map<string, string>();
    map['position'] = 'relative';
    map['top'] = '0';
    map['width'] = '100%';
    map['margin-left'] = '0';
    map['will-change'] = 'filter';
    map['filter'] = 'none';
    map['border-bottom-left-radius'] = '0';
    map['border-bottom-right-radius'] = '0';

    return map;
  }

  private getItemCount(adjustedDisplayItems: Array<DisplayItem>, testFunction: (item: Item) => boolean): number {
    return adjustedDisplayItems.filter((displayItem) => {
      return displayItem instanceof Item && testFunction(displayItem as Item);
    }).length;
  }

  private getSpan(text: string, backgroundColor: string, borderColor: string): string {
    return (
      '<span style="padding: 5px; border-radius: 5px; background-color:' +
      backgroundColor +
      '; border: 1px solid ' +
      borderColor +
      ';">' +
      text +
      '</span>'
    );
  }
}

export default TestReviewScreenDisplayStrategy;
